import { useEffect } from "react";
import { useCoinsStore } from "../stores/coins.store";

const CoinsEffect: React.FC = () => {
  // Listen for changes to the coins collection in Firestore
  const [activeWebsockets, updateCoin] = useCoinsStore((state: any) => [
    state.activeWebsockets,
    state.updateCoin
  ]);

  useEffect(() => {
    // console.log('Websockets', activeWebsockets);
    if (!activeWebsockets.length) {
      return;
    }
    const ws = new WebSocket("wss://stream.binance.com:9443/ws");
    ws.onopen = () => {
      ws.send(
        JSON.stringify({
          method: "SUBSCRIBE",
          params: activeWebsockets,
          id: 1
        })
      );
    };

    ws.onerror = error => {
      console.error("WebSocket error", error);
    };

    ws.onmessage = evt => {
      // Parse the JSON message
      // @ts-ignore
      const message = JSON.parse(evt.data);
      // Check if the message is for a USDT trading pair
      if (message.s?.endsWith("USDT")) {
        const coin = {
          symbol: message.s,
          price: parseFloat(message.c),
          change: parseFloat(message.p),
          changePercent: message.P,
          timestamp: message.E
        };
        updateCoin(coin.symbol, coin);
      }
    };

    // When component unmounts, clean up by closing the websocket connection
    return () => {
      console.log("closing websocket");
      ws.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeWebsockets]);

  return null;
};

export default CoinsEffect;
